import { getImageSizeString } from '@tunasong/models'
import { isStorageUrlsExpired, type Entity, type ImageSizeType } from '@tunasong/schemas'

/** Get URLs to the image and scaled sizes. We use a Lambda@Edge function to resize images for URLs from storage */
export const useImage = (image?: Entity, size: ImageSizeType = 'large') => {
  /** Signed wildcard URL, we add the dimensions as query parameters. That is handled in a Lambda@Edge function running sharp */

  const isExpired = isStorageUrlsExpired(image?.storageUrls)
  const url = !isExpired ? image?.storageUrls?.url : undefined
  const isBlobUrl = url?.startsWith('blob:')

  if (isBlobUrl) {
    return url
  }
  if (url) {
    return `${url}&d=${getImageSizeString(size)}`
  }

  return undefined
}
